/** UI copy from Confluence PRD/FDD — Terms of Services and Privacy Policy (page 13860866). */
export const CONSENT_COPY = {
  checkboxPrefix: "I have read and agree to the",
  checkboxSuffix: ".",
  accountValidationError:
    "You must accept the Terms of Service and Privacy Policy to create an account.",
  reconsentValidationError:
    "You must accept the Terms of Service and Privacy Policy to continue.",
  loginNoticePrefix: "By signing in, you agree to our",
  loginNoticeSuffix: ".",
  reconsentBody:
    "Our legal documents have been updated. Please review and accept the current versions to continue using QA Path.",
  reconsentHint:
    "Use the links below to open each document, then check the box to continue.",
  acceptanceNotRecorded: "Acceptance date not recorded.",
  statusUpToDate: "Up to date",
  statusUpdateRequired: "Update required",
  statusUnavailable: "Status unavailable",
};
